module.exports = {"us":"Северной и Южной Америки","eu":"Европа","cn":"Китай","tw":"Тайвань","kr":"Корея","world":""};